"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var info_1 = __importDefault(require("./info"));

var events = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick', 'onScroll'];

var Frame = function Frame(props, ref) {
  var _a;

  var style = props.style,
      _b = props.customStyle,
      customStyle = _b === void 0 ? {} : _b,
      children = props.children,
      x = props.x,
      y = props.y,
      z = props.z,
      left = props.left,
      top = props.top,
      right = props.right,
      bottom = props.bottom,
      w = props.w,
      h = props.h,
      minWidth = props.minWidth,
      minHeight = props.minHeight,
      maxWidth = props.maxWidth,
      maxHeight = props.maxHeight,
      _c = props.clipContent,
      clipContent = _c === void 0 ? false : _c,
      fixedPositionWhenScrolling = props.fixedPositionWhenScrolling,
      _d = props.autoLayout,
      autoLayout = _d === void 0 ? false : _d,
      // 对应 figma 中的 AutoLayout
  _e = props.flex,
      // 对应 figma 中的 AutoLayout
  flex = _e === void 0 ? false : _e,
      // 对应 figma 中的 AutoLayout
  _f = props.flexAuto,
      // 对应 figma 中的 AutoLayout
  flexAuto = _f === void 0 ? false : _f,
      _g = props.flexWrap,
      flexWrap = _g === void 0 ? false : _g,
      gap = props.gap,
      _h = props.direction,
      direction = _h === void 0 ? 'row' : _h,
      grid = props.grid,
      cols = props.cols,
      rows = props.rows,
      padding = props.padding,
      fill = props.fill,
      stroke = props.stroke,
      bg = props.bg,
      color = props.color,
      resizing = props.resizing,
      // 对应 figma 中的属性，取值为以下三种：fixedWidth, fillContainer, fixedHeight
  _j = props.usePosition,
      // 对应 figma 中的属性，取值为以下三种：fixedWidth, fillContainer, fixedHeight
  usePosition = _j === void 0 ? false : _j,
      alignItems = props.alignItems,
      justifyContent = props.justifyContent,
      rotation = props.rotation,
      radius = props.radius,
      _k = props.inlineFlex,
      inlineFlex = _k === void 0 ? false : _k,
      _l = props.inlineGrid,
      inlineGrid = _l === void 0 ? false : _l,
      block = props.block,
      inlineBlock = props.inlineBlock,
      _m = props.bordered,
      bordered = _m === void 0 ? false : _m,
      title = props.title,
      _o = props.useClassName,
      useClassName = _o === void 0 ? true : _o,
      pos = props.position,
      _p = props.as,
      Tag = _p === void 0 ? 'div' : _p;
  var position = pos;

  if (fixedPositionWhenScrolling) {
    position = 'sticky';
  } else if (usePosition) {
    position = 'absolute';
  }

  var cssObj = __assign(__assign({
    width: w,
    height: h,
    minWidth: resizing === 'fixedWidth' ? w : minWidth,
    minHeight: resizing === 'fixedHeight' ? h : minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    left: (0, spaui_utils_1.pxVal)(left) || x,
    top: (0, spaui_utils_1.pxVal)(top) || y,
    right: right,
    bottom: bottom,
    background: fill,
    border: stroke,
    transform: rotation ? "rotate(".concat(rotation, ")") : null,
    zIndex: z,
    color: color
  }, customStyle), style);

  return react_1["default"].createElement(Tag, __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])((_a = {
      'odc-frame': useClassName,
      flex: (flex || autoLayout) && !inlineFlex,
      'inline-flex': inlineFlex,
      'overflow-hidden': clipContent,
      'flex-auto': flexAuto || resizing === 'fillContainer'
    }, _a["flex-".concat(direction)] = (flex || autoLayout || inlineFlex) && direction, _a['flex-wrap'] = flexWrap, _a["radius-".concat(radius)] = radius, _a["gap-".concat(gap)] = gap, _a["p-".concat(padding)] = padding, _a["items-".concat(alignItems)] = alignItems, _a["justify-".concat(justifyContent)] = justifyContent, _a["bg-".concat(bg)] = bg, _a.grid = grid, _a.border = bordered, _a['inline-grid'] = inlineGrid, _a["grid-cols-".concat(cols)] = cols, _a["grid-rows-".concat(rows)] = rows, _a.block = block, _a['inline-block'] = inlineBlock, _a), position),
    events: events,
    ref: ref
  }, Frame), {
    style: cssObj,
    title: title
  }), children);
};

(0, spaui_utils_1.setComponentMark)(Frame, info_1["default"]);
exports["default"] = react_1["default"].memo((0, react_1.forwardRef)(Frame));